import { rem } from 'polished';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Event, BigPictureClient } from '@vimeo/bigpicture-client';
import { translate } from '@vimeo/i18n-runtime';
import { blue, white } from '@vimeo/iris/color';
import { Button } from '@vimeo/iris/components';

/**
 * This is a header component which is to be shown to users coming in from FB business manager context
 * to vimeo create and then wanders away from create pages.
 */
export default function FBCreativeContextBanner() {
  useEffect(() => {
    BigPictureClient.sendEvent(
      new Event('view_blue_notification_for_fb_users', 1, {
        product: 'Vimeo Create',
        location: 'vimeo_website',
        path: window.location.pathname,
        type: 'impression',
      }),
    );
  }, []);
  return (
    <Wrapper>
      {translate('Resume creating videos for your Facebook Business account?')}
      &nbsp;
      <ButtonWrapper>
        <StyledButton
          size="xs"
          onClick={() => {
            BigPictureClient.sendEvent(
              new Event('click_on_blue_notification_for_fb_users', 1, {
                product: 'Vimeo Create',
                location: 'vimeo_website',
                cta: 'create_new_video',
                path: window.location.pathname,
                type: 'click',
              }),
            ).then(() => {
              window.location.href = '/create/templates';
            });
          }}
        >
          {translate('Create new video')}
        </StyledButton>
        <DoneWrapper
          size="xs"
          variant="hyperminimal"
          onClick={() => {
            document.cookie = 'create_fb_context=1;path=/;Max-Age=-99999999;';
            BigPictureClient.sendEvent(
              new Event('click_on_blue_notification_for_fb_users', 1, {
                product: 'Vimeo Create',
                location: 'vimeo_website',
                cta: 'im_done',
                path: window.location.pathname,
                type: 'click',
              }),
            ).then(() => {
              window.location.reload();
            });
          }}
        >
          {translate("I'm done")}
        </DoneWrapper>
      </ButtonWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: ${rem(64)};
  font-size: ${rem(14)};
  background: ${blue(600)};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;

  @media (min-width: ${rem(768)}) {
    height: ${rem(32)};
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;

  @media (min-width: ${rem(768)}) {
    width: unset;
  }
`;

const StyledButton = styled(Button)`
  margin: 0 ${rem(12)};
  background: ${blue(400)};

  &:hover {
    background: ${blue(500)};
  }
`;

const DoneWrapper = styled(Button)`
  color: ${white};

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;
